import { useMutation, useQueryClient } from 'react-query';
import { useCurrentUser, useToastProvider } from '@qualio/ui-components';
import formsApi from '../api/forms.api';
import { DefaultErrorMessage } from '../displayStrings';
import { useEventFormParams } from './useEventFormParams';

export const useFormReassign = () => {
  const { eventId, stepId, formId } = useEventFormParams();
  const { companyId } = useCurrentUser();
  const { showToast } = useToastProvider();
  const queryClient = useQueryClient();

  return useMutation(
    (newAssigneeId: number) => formsApi.updateForm(companyId, eventId, stepId, formId, { owner_id: newAssigneeId }),
    {
      onSuccess: async (data) => {
        await queryClient.invalidateQueries(['formDetails', formId]);
        await queryClient.invalidateQueries(['reviewersList', companyId, formId]);
        await queryClient.invalidateQueries(['approversList', companyId, formId]);
        showToast({
          title: 'User reassigned',
          description: `${data.title} is reassigned to ${data.owner_full_name}`,
          status: 'success',
          duration: 5000,
          'data-cy': 'qe-form-reassign-success-toast',
        });
      },
      onError: (err: any) => {
        const message = err?.response?.data?.message || DefaultErrorMessage;
        showToast({
          description: message,
          status: 'error',
          duration: 5000,
        });
      },
    },
  );
};
